import React from "react";
import MeditationHero from "../components/meditation/MeditationHero";
import MeditationContent from "../components/meditation/MeditationContent";

const Meditation = () => {
  return (
    <>
      <MeditationHero />
      <MeditationContent />
    </>
  );
};

export default Meditation;
